// src/pages/seo/components/UndoChip.tsx

import React from 'react';
type Props = { onUndo: () => void };
export function UndoChip({ onUndo }: Props) {
  return (
    <button className="ml-2 text-xs underline" onClick={onUndo} title="Undo this field">Undo</button>
  );
}